import { getHandlers } from '../utils.js'

const DEDUPE_FIELDS = [
  'deviceType (device)',
  'Estid/CookieID',
  'IP (MUST BE HASHED)',
  'StandardTimestamp',
]

const handleDedupeFieldsChange = (onChange, _, all) => {
  const options = all.filter((pair) => DEDUPE_FIELDS.includes(pair[1])).map((pair) => pair[1])

  onChange({}, 'dedupe_fields', options)
}

export default getHandlers(DEDUPE_FIELDS, handleDedupeFieldsChange)
